"use strict";
/*!
 *
 *  menu.ts
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () {
    var $menu = $('#menu');
    var $btn = $menu.children('.l_menu_btn').children('a');
    var $body = $('#menuBody');
    $btn.on('click', function (e) {
        e.preventDefault();
        $menu.toggleClass('-expanded');
        $body.stop(false, true).animate({
            height: 'toggle'
        }, 500, 'easeOutQuart');
    });
    $(document).on('click', function (e) {
        if (!$(e.target).closest('#menu').length) {
            if ($menu.is('.-expanded')) {
                $menu.removeClass('-expanded');
                $body.stop(false, true).animate({
                    height: 'hide'
                }, 500, 'easeOutQuart');
            }
            ;
        }
        ;
    });
});
